import React from "react";
import { motion } from "framer-motion";
import { StarIcon } from "lucide-react";
import { TESTIMONIALS } from "./data";
import { TransformButton } from "./TransformButton";
function Stars() {
  return <div className="flex gap-0.5" data-id="element-229" data-mp="3fyvwm62op58z">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 text-amber-400" fill="#fbbf24" data-id="element-230" data-mp="3b146nhllnt7f" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-[var(--cream)] px-4 py-14" data-id="element-231" data-mp="370ajiqfzeifl">
      <div className="mx-auto max-w-2xl" data-id="element-232" data-mp="31zms43nubzku">
        <div className="text-center" data-id="element-233" data-mp="31yl8hasre4ri">
          <h2 className="font-serif-display text-2xl font-extrabold text-gray-900 sm:text-3xl" data-id="element-234" data-mp="2x0jqyuazedi5">
            ⭐ Lo que opinan otros odontólogos
          </h2>
          <div className="mt-3 flex items-center justify-center gap-2" data-id="element-235" data-mp="2s3jfu4z9ykk6">
            <Stars data-id="element-236" data-mp="v858nu4iz717" />
            <span className="text-sm font-bold text-gray-700" data-id="element-237" data-mp="v8nd3e1ccrk7">4.9/5</span>
          </div>
          <p className="mt-2 text-sm text-gray-500" data-id="element-238" data-mp="qavbfsaw9r2t">
            Más de <strong className="text-[var(--brand)]" data-id="element-239" data-mp="h5ezbmd4bx17">1.200 odontólogos</strong> ya utilizan Protocolo Clínica Segura™
          </p>
        </div>

        <div className="mt-8 space-y-4" data-id="element-240" data-mp="m6m55fvpam58">
          {TESTIMONIALS.map((t, i) => <motion.div key={t.name} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 2 * 0.06
        }} className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm" data-id="element-241" data-mp="7926srtb7p81" data-mpi={i}>
              <div className="mb-3 flex items-center gap-3" data-id="element-242" data-mp="14xdewijloek5">
                <img src={t.avatar} alt={`Foto de ${t.name}`} className="h-12 w-12 shrink-0 rounded-full object-cover ring-2 ring-[var(--brand)]/15" loading="lazy" data-id="element-243" data-mp="q5v2eupy925j" />
                <div data-id="element-244" data-mp="1nlqq32dm2cmr">
                  <p className="text-sm font-bold text-gray-900" data-id="element-245" data-mp="1nma7mhzcmz09">
                    {t.name} <span className="text-base" data-id="element-246" data-mp="1xhqxbmoczosy">{t.flag}</span>
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-247" data-mp="1xfmul8274vu9">{t.country}</p>
                  <div className="mt-0.5" data-id="element-248" data-mp="1sjfptiljdqdw"><Stars data-id="element-249" data-mp="1sh3896joxi1d" /></div>
                </div>
              </div>
              <p className="text-sm leading-relaxed text-gray-700" data-id="element-250" data-mp="1ofrf4r1lyeof">“{t.text}”</p>
            </motion.div>)}
        </div>

        <TransformButton label="Quiero sentirme así de seguro" data-id="element-251" data-mp="1jkkjm6ihsgal" />
      </div>
    </section>;
}